import { SignatureCardTheme } from "../SignatureCard.types";

const SKEW_DEG = -15;
const CARD_BORDER_RAD_PX = "60px";
const SHAPE_BORDER_RAD_PX = "100px";
const SHAPE_HEIGHT = 75; // %

const baseTheme: SignatureCardTheme = {
	base: {
		boxSizing: "border-box",
		position: "relative",
		minHeight: "420px",
		width: "100%",
		borderRadius: CARD_BORDER_RAD_PX,
		display: "flex",
		alignItems: "center",
		clipPath: `inset(0 0 0 0 round ${CARD_BORDER_RAD_PX})`,
		overflow: "hidden",

		"::before, ::after": {
			content: "'.'",
			color: "transparent",
			position: "absolute",
			height: `${SHAPE_HEIGHT}%`,
			width: "50%",
			backgroundColor: "#000000",
			opacity: ".04",
			transform: `skew(${SKEW_DEG}deg)`,
			transition: "transform .5s;",
		},

		"::before": {
			top: "0",
			left: `${
				Math.round(SHAPE_HEIGHT * Math.tan((SKEW_DEG * Math.PI) / 180)) / 2
			}%`,
			borderRadius: `0 0 ${SHAPE_BORDER_RAD_PX} 0`,
		},

		"::after": {
			bottom: "0",
			right: `${
				Math.round(SHAPE_HEIGHT * Math.tan((SKEW_DEG * Math.PI) / 180)) / 2
			}%`,
			borderRadius: `${SHAPE_BORDER_RAD_PX} 0 0 0`,
			transform: "skew(-15deg) translate(0, 200px)",
		},
	},

	breakpoint: {
		md: {
			"::before": {
				transform: "skew(-15deg) translate(0, 0)",
			},

			"::after": {
				transform: "skew(-15deg) translate(0, 0)",
			},
		},

		lg: {
			"::before": {
				transform: "skew(-15deg) translate(0, 0)",
			},

			"::after": {
				transform: "skew(-15deg) translate(0, 0)",
			},
		},

		xl: {
			"::before": {
				transform: "skew(-15deg) translate(0, 0)",
			},

			"::after": {
				transform: "skew(-15deg) translate(0, 0)",
			},
		},

		xxl: {
			"::before": {
				transform: "skew(-15deg) translate(0, 0)",
			},

			"::after": {
				transform: "skew(-15deg) translate(0, 0)",
			},
		},
	},
};

export default baseTheme;
